import type { Dashboard } from '../types';

export function generateSuggestedPrompts(dashboard: Dashboard): { label: string; prompt: string }[] {
  const prompts: { label: string; prompt: string }[] = [
    {
      label: 'Explain this dashboard',
      prompt: 'Explain what this dashboard shows and what insights I can get from it.',
    },
    {
      label: 'Any data quality issues?',
      prompt: "Check this dashboard's data for quality issues — nulls, anomalies, or unexpected patterns.",
    },
  ];

  // Add panel-specific prompts (cap at 2)
  let added = 0;
  for (const panel of dashboard.spec.panels) {
    if (added >= 2) break;
    switch (panel.type) {
      case 'metric':
        prompts.push({
          label: `What drives ${panel.title}?`,
          prompt: `What's driving the "${panel.title}" number? Break down the key factors.`,
        });
        added++;
        break;
      case 'chart':
        prompts.push({
          label: `Why did ${panel.title} change?`,
          prompt: `Why did "${panel.title}" change recently? Look for trends, spikes, or drops.`,
        });
        added++;
        break;
      case 'table':
        prompts.push({
          label: `Summarize ${panel.title}`,
          prompt: `Summarize the trends in "${panel.title}" and highlight anything unusual.`,
        });
        added++;
        break;
      case 'funnel':
        prompts.push({
          label: `Where are users dropping off?`,
          prompt: `In the "${panel.title}" funnel, where are users dropping off and why?`,
        });
        added++;
        break;
    }
  }

  return prompts.slice(0, 4);
}
